const Maintenance = {

    // FIELDS
    "maintenance": "Maintenance",
    "corrective_maintenance": "CORRECTIVE",
    "preventive_maintenance": "PREVENTIVE",
    "schedule_maintenance": "Schedule Maintenance",
    "asset": "Asset",
    "maintenance_type": "Maintenance Type",
    "description": "Description",
    "assigned_to": "Assigned To",
    "scheduled_date": "Scheduled Date",
    "completed_date": "Completed Date",
    "status": "Status",
    "priority": "Priority",
    "search": "Search",
    "job_order": "Job Order",
    "job_card": "Job Card",
    "parts": "Parts",
    "tools": "Tools",
    "quantity": "Quantity",
    "cost": "Cost",

    // PAGE HEADER
    "list_title": "Maintenance",
    "corrective_list_title": "Corrective Maintenance",
    "preventive_list_title": "Preventive Maintenance",
    "job_order_list_title": "Job Order List",
    "filter_title": "Maintenance Filter",

    // TABLE HEADER
    "table_asset": "Asset",
    "table_maintenance_type": "Maintenance Type",
    "table_assigned_to": "Assigned To",
    "table_scheduled_date": "Scheduled Date",
    "table_status": "Status",
    "table_priority": "Priority",

    // ERROR
    "error_asset": "Select Asset",
    "error_maintenance_type": "Select Maintenance Type",
    "error_description": "Enter Description",
    "error_assigned_to": "Select Assigned To",
    "error_scheduled_date": "Select Scheduled Date",
    "error_status": "Select Status",
    "error_priority": "Select Priority",
    "error_parts": "Select Parts",
    "error_quantity": "Enter Quantity",
    "error_cost": "Enter Cost",

}

export default Maintenance;

